import Wristband from "images/wristband.png";
import WristbandEmpty from "images/accessories/wristband-empty.png";
const Accessories = {
  Wristband,
  WristbandEmpty,
};
export default Object.freeze(Accessories);
